import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Replace with your API base URL
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["x-access-token"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
